import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import { ADMIN_CONSENTS_ON_PARTNER_TYPES } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';
import PartnerConsentsContainer from './PartnerConsentsContainer';
import { Typography } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
          {t('Dashboard.PartnerConsent.Text')}
        </Typography>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_CONSENTS_ON_PARTNER_TYPES}>
        <PartnerConsentsContainer />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
